export const mediaDevices: MediaDevices = navigator.mediaDevices;

